import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashTableComponent } from './dash-table.component';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { SisColValueComponent } from '@smartera/components';

@NgModule({
	declarations: [DashTableComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,

		TableModule,
		ToggleSwitchModule,
		ButtonModule,
		SisColValueComponent,
	],
	exports: [DashTableComponent],
})
export class DashTableModule {}
